import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { observable } from 'mobx';
import { EventValueField } from 'src/app/rules/rules/form/parts/conditions/event-value.field';


interface SendEmailExecutorProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
	event: PublicEventItem;
}

interface IState {
	emailTarget: 'Raw' | 'EventField'
}

@observer
export class SendEmailExecutor extends React.Component<SendEmailExecutorProps, IState> {
	

	@observable
	email: string;

	@observable
	subject: string;

	@observable
	emailField: string[];

	constructor(props) {
		super(props);

		this.state = {
			emailTarget: 'Raw'
		}
	}

	public componentDidMount() {
		if (this.props.values)

			this.email = this.props.values['email'];
			this.emailField = this.props.values['emailField']? JSON.parse(this.props.values["emailField"]): [];
			this.subject = this.props.values['subject'];

			this.setState({ emailTarget: this.props.values["emailTarget"] || 'Raw' });

			this.props.values.validate = () => {

				const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

				if (!this.props.values['email'] && !this.props.values["emailField"])
					return { result: false, errors: "The email address is required for SendEmailExecutor. \n" };

				if (!re.test(this.props.values['email']))
					return { result: false, errors: "The email address is not a valid email in SendEmailExecutor. \n" };
				if (!this.props.values['subject'])
					return { result: false, errors: "The subject is required for SendEmailExecutor. \n" };

				return { result: true, errors: "" };
			}
	}

	render() {

		const { values } = this.props;
		
		return (
			<React.Fragment>

				<Row gutter={24}>
					<Col xs={24}>
						<p>The Subject and Body field will be rendered using Razor Engine. The injected viewmodel will be the rule event, watch out the available fields</p>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col xs={12}>
						<TextView
							label='Email address'
							mode={this.props.mode}
							value={this.email}
							onChanged={(e) => {
								this.email = e;
								this.props.onFieldChange("email", e)
							}
							}
						/>
					</Col>
					<Col xs={12}>
						{this.props.event && this.props.event.properties && <EventValueField
							label='Email field on event struct'
							mode={this.props.mode}
							properties={this.props.event.properties}
							value={this.emailField}
							onChange={(e) => {
								const mapping = e.map(item => item.propertyName)
								this.emailField = mapping;
								this.props.onFieldChange("emailField", JSON.stringify(mapping))
							}
							}
						/>}
					</Col>
				</Row>
				<Row gutter={24}>

					<Col xs={24}>
					<TextView
						label='Subject'
						mode={this.props.mode}
						value={this.subject}
						onChanged={(e) => {
							this.subject = e;
							this.props.onFieldChange("subject", e)
						}
					}
					/>

					</Col>
				</Row>
				<Row gutter={24}>

					<Col xs={24}>
						<RichTextView
							label='Body'
							mode={this.props.mode}
							value={values["bodyTemplate"]}
							onChanged={(e) => this.props.onFieldChange("bodyTemplate", e)}
						/>

					</Col>
				</Row>
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/send-email.executor.tsx